import { GameVars } from "./../../GameVars";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../managers/GameManager";
import { RoomManager } from "../../managers/RoomManager";
import { Button } from "../../utils/Button";
import { AudioManager } from "../../managers/AudioManager";

export class QuitLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000, .9);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        background.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        background.on("pointerdown", () => { 
            this.onClickNo(); 
        });
        this.add(background);

        const midContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, 0);
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        const confirmationLabel = new Phaser.GameObjects.Text(this.scene, 0, 275, "ARE YOU SURE YOU WANT TO QUIT?", {fontFamily: "Oswald-Medium", fontSize: "34px", color: "#ffffff"});
        confirmationLabel.setOrigin(.5);
        midContainer.add(confirmationLabel); 

        const yesButton = new Button(this.scene, -80, 350, "texture_atlas_1", "btn_blue.png", "btn_blue.png");
        yesButton.setOrigin(.5);
        yesButton.onUp(this.onClickYes, this);
        midContainer.add(yesButton);

        let yesText = new Phaser.GameObjects.Text(this.scene, -80, 350, "YES", {fontFamily: "Oswald-Medium", fontSize: "30px", color: "#064150", align: "center"});
        yesText.setOrigin(.5);
        midContainer.add(yesText);

        const noButton = new Button(this.scene, 80, 350, "texture_atlas_1", "btn_red.png", "btn_red.png");
        noButton.setOrigin(.5);
        noButton.onUp(this.onClickNo, this);
        midContainer.add(noButton);

        let noText = new Phaser.GameObjects.Text(this.scene, 80, 350, "NO", {fontFamily: "Oswald-Medium", fontSize: "30px", color: "#871947", align: "center"});
        noText.setOrigin(.5);
        midContainer.add(noText);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450
        });
    }

    private onClickYes(): void {

        AudioManager.playSound("btn_click");

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Enter Splash";
            } else {
                GameManager.enterSplashScene();
            }
        } else {
            GameManager.enterSplashScene();
        }
    }

    private onClickNo(): void {

        AudioManager.playSound("btn_click");
        
        RoomManager.removeQuitLayer();
    }
}
